import { render, staticRenderFns } from "./FairDocuments.vue?vue&type=template&id=dd0c7d04&scoped=true"
import script from "./FairDocuments.vue?vue&type=script&lang=js"
export * from "./FairDocuments.vue?vue&type=script&lang=js"
import style0 from "./FairDocuments.vue?vue&type=style&index=0&id=dd0c7d04&prod&lang=scss"
import style1 from "./FairDocuments.vue?vue&type=style&index=1&id=dd0c7d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0c7d04",
  null
  
)

export default component.exports